module.exports = __webpack_public_path__ + "img/6.6913d30b.png";